// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2lvjt","vLegacy":"SelectSecondary_vLegacy__1l0yi","error":"SelectSecondary_error__nKsja","disabled":"SelectSecondary_disabled__2E_NV"};